import * as React from 'react';
import { Tile } from './tiles-item';
import styles from './tiles-index.scss';

export interface TilesIndexProps {
  groups: string[];
  activeGroup?: string;
  selectGroup?: (group: string) => void;
}

export const TilesIndex = ({ groups, activeGroup, selectGroup }:TilesIndexProps) => {

  return (
    <div className={styles.alphabetControl}>
      {groups.map(item =>
        <Tile 
          key={item} 
          name={item}
          isSelected={item === activeGroup} 
          onClick={selectGroup} 
        />
      )}
    </div>
  );

};
